import { C, DELEG_CELL, DELEG_ZONES, FRECUENCIA_OPTS, RIESGO_OPTS } from "./constants";

const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

const ZoneTag = ({ zona }) => (
  <span className="inline-block rounded-md px-2 py-0.5 text-[11px] font-bold" style={{ background: DELEG_ZONES[zona].bg, color: DELEG_ZONES[zona].fg }}>{zona}</span>
);

const Grid = ({ rows }) => (
  <div className="hidden md:grid gap-2" style={{ gridTemplateColumns: "110px repeat(2, minmax(0, 1fr))" }} data-testid="tablero-deleg-grid">
    <div />
    {RIESGO_OPTS.map((r) => <div key={r.v} className="text-[12px] font-bold text-center pb-1" style={{ color: C.text }}>{r.l}</div>)}
    {FRECUENCIA_OPTS.map((f) => [
      <div key={`l-${f.v}`} className="text-[12px] font-bold flex items-center" style={{ color: C.text }}>{f.l}</div>,
      ...RIESGO_OPTS.map((r) => {
        const zona = DELEG_CELL[`${f.v}-${r.v}`];
        return (
          <div key={`${f.v}-${r.v}`} className="rounded-lg p-2.5 min-h-[96px] flex flex-col gap-1.5" style={{ background: DELEG_ZONES[zona].bg }}>
            <span className="text-[10px] font-bold uppercase tracking-[0.14em]" style={{ color: DELEG_ZONES[zona].fg }}>{zona}</span>
            {rows.filter((d) => d.frecuencia === f.v && d.riesgo === r.v).map((d) => (
              <span key={d.orden} className="rounded-md bg-white px-2 py-1 text-[12px] font-semibold border" style={{ color: C.text, borderColor: "rgba(14,31,25,0.15)" }}>{cap(d.nombre)}</span>
            ))}
          </div>
        );
      }),
    ])}
  </div>
);

export const DelegationResult = ({ rows, contador }) => (
  <div className="space-y-4" data-testid="tablero-deleg-result">
    <p className="text-lg font-bold" style={{ color: C.green }} data-testid="tablero-deleg-contador">{contador}</p>
    <Grid rows={rows} />
    <div className="space-y-2">
      {rows.map((d, i) => (
        <div key={d.orden} className="rounded-xl bg-white border p-4" style={{ borderColor: "#E3E7E1" }} data-testid={`tablero-deleg-item-${i + 1}`}>
          <div className="flex flex-wrap items-center gap-2 mb-1">
            <span className="text-[15px] font-bold" style={{ color: C.text }}>{cap(d.nombre)}</span>
            <ZoneTag zona={d.zona} />
          </div>
          <p className="text-sm" style={{ color: C.text }}>{d.texto}</p>
        </div>
      ))}
    </div>
  </div>
);
